/*
*   File : overview.js
*   Author : https://evoqins.com
*   Description : Overview data page
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

//Style
import style from "../../../Styles/Component/basket.module.scss";

//Custom components
import { TextButton } from '../../../Component/Buttons';

const Overview = (props) => {

    const navigate = useNavigate();

    let data = props.data;

    // navigate to creator detail page
    const _handleNavigateToCreatorDetail = () => {
        navigate("/explore/creator-detail", {
            state: {
                creator_id: Number(data.creator_info.creator_id)
            }
        });
    };

    // navigate to subscription
    const _handleNavigateToSubscription = () => {
        navigate("/subscriptions");
    };

    return (
        <Fragment>
            {/* About  */}
            <div className='pt-4'>
                <h6 className='mb-2 e-primary-font-clash-display e-text-black e-font-16 e-font-weight-500 line-height-24px'>
                    About
                </h6>
                <p className='e-font-14-res mb-3 e-alt-font-lato e-text-outer-space e-font-16 e-font-weight-400 line-height-26px'>
                    {data.strategy_desc}
                </p>

                {
                    data.factsheet_url &&
                    <a href={data.factsheet_url}
                        target='_blank'
                        className='text-decoration-none text-reset d-flex gap-2 align-items-center cursor-pointer'>
                        <img src={require("../../../Assets/Images/Other/factsheet.svg").default} />
                        <span className='e-font-14-res e-alt-font-lato e-text-primary-color e-font-16 e-font-weight-600 line-height-20px'>
                            Factsheet
                        </span>
                    </a>
                }
            </div>

            {/* Methodology  */}
            <div className='pt-4'>
                <h4 className='mb-3 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                    Methodology
                </h4>
                <div className='row row-gap-4'>
                    <div className='col-12 col-lg-6'>
                        <div className={`h-100 ${style.e_methodology_card} ${props.subscription === false ? 'cursor-pointer ' : 'pe-none'} py-3 padding-12px-lr `}
                            onClick={props.handleSubscribe}>

                            <div className='d-flex align-items-center gap-1 pb-2'>
                                <img src={require("../../../Assets/Images/Basket/universe-selection.svg").default}
                                    draggable={false}
                                    alt='universe-selection-icon' />
                                <h6 className='mb-0 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-22px'>
                                    Universe Selection
                                </h6>
                            </div>
                            <p className='mb-0 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-22px'>
                                {data.universe_selection}
                            </p>

                        </div>
                    </div>
                    <div className='col-12 col-lg-6'>
                        <div className={`h-100 ${style.e_methodology_card} ${props.subscription === false ? 'cursor-pointer ' : 'pe-none'} py-3 padding-12px-lr `}
                            onClick={props.handleSubscribe}>

                            <div className='d-flex align-items-center gap-1 pb-2'>
                                <img src={require("../../../Assets/Images/Basket/stock-selection.svg").default}
                                    draggable={false}
                                    alt='universe-selection-icon' />
                                <h6 className='mb-0 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-22px'>
                                    Stock Selection & Screening
                                </h6>
                            </div>
                            <p className='mb-0 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-22px'>
                                {data.stock_selection}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Creator  */}
            <div className='pt-4'>
                <h4 className='mb-2 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                    About Creator
                </h4>

                <div className={`${style.e_about_creator_card_wrapper} border-radius-16`}>
                    <div className={`${style.e_about_creator_card} d-flex flex-column flex-sm-row gap-3 border-radius-16 p-3`}>
                        <div className='align-self-start'>
                            <img src={data.creator_info.creator_logourl}
                                draggable={false}
                                width={104}
                                height={104}
                                className='h-50px-res w-50px-res bg-white border-radius-18 e-border-1px-anti-flash-white p-1'
                                alt='portfolio' />
                        </div>

                        <div>
                            <h6 className='my-1 e-alt-font-lato e-text-black e-font-16 e-font-weight-600 line-height-20px'>
                                {data.creator_info.creator_name}
                            </h6>
                            <p className='mb-2 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-600 line-height-20px'>
                                {data.creator_info.creator_experience}  {data.creator_info.creator_experience === '1' ? "year" : "years"}  experience
                            </p>
                            <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-400 line-height-22px'>
                                Wealth Creation through a strong fundamental research and disciplined investing. Top performing research house!
                                {data.creator_info.creator_description}
                            </p>
                            <TextButton name="View details"
                                type={3}
                                icon={true}
                                onPress={_handleNavigateToCreatorDetail} />
                        </div>
                    </div>
                </div>

                {/* Subscription detail data */}
                {data.is_subscribed &&
                    <div className={`${style.e_subscription_detail_card_wrapper} mt-4 border-radius-16 cursor-pointer`}>
                        <div className={`${style.e_subscription_detail_card} border-radius-16 p-3`}>
                            <div className='row'>
                                <div className='col-sm-8'>
                                    <h6 className='my-1 e-alt-font-lato e-text-black e-font-16 e-font-weight-600 line-height-20px'>
                                        Subscription Details
                                    </h6>
                                    <div className='py-3 d-flex gap-68px'>
                                        <div>
                                            <p className='mb-1 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-18px'>
                                                Subscribed on
                                            </p>
                                            <p className='mb-0 e-alt-font-lato e-text-chinese-back e-font-14 e-font-weight-600 line-height-20px'>
                                                {data.subscribed_on}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='mb-1 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-18px'>
                                                Due Date
                                            </p>
                                            <p className='mb-0 e-alt-font-lato e-text-chinese-back e-font-14 e-font-weight-600 line-height-20px'>
                                                {data.due_date}
                                            </p>
                                        </div>
                                    </div>
                                    <TextButton name="View details"
                                        onPress={_handleNavigateToSubscription}
                                        type={3}
                                        icon={true} />
                                </div>

                                <div className='col-4 text-end d-none d-sm-block'>
                                    <img src={require("../../../Assets/Images/Card/subscription-detail-img.png")}
                                        draggable={false}
                                        className='img-fluid'
                                        alt='portfolio' />
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Fragment>
    )
}

export default Overview;
